import { Component, OnInit, Input } from '@angular/core';
import { LaudoInput } from 'src/app/models/laudo-input';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { ActivatedRoute } from '@angular/router';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-element-template-builder',
  templateUrl: './element-template-builder.component.html',
  styleUrls: ['./element-template-builder.component.scss']
})
export class ElementTemplateBuilderComponent implements OnInit {

  @Input() element:LaudoInput;
  @Input() preview:LaudoInput;
  @Input() templateLabel:string = '';
  @Input() useTemplateLabel:boolean = true;

  constructor(private laudoService: LaudoUnionService, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
  }

  async saveImage(element:LaudoInput, base64) {
    try {
      element.loading = true;
      let token = this.activatedRoute.snapshot.paramMap.get('id');
      const blob = base64 ?  await Utils.base64ToBlob(base64) : null;
      const response = await this.laudoService.updateImageInput( element.name, blob, element.formId || token )
      if(response) {  
        element.control.patchValue(response.value || '');
      }else{
        element.control.patchValue('');
      }
    } catch (error) {
      console.error(error);
    } finally {
      element.loading = false;
    }

  }

  focusIn(popoverElement) {
    if (this.element.control.disabled || this.element.loading) return;

    if (this.preview) {
      popoverElement.open();
    }
  }

  focusOut(popoverElement) {
    if (this.preview) {
      setTimeout(() => {
        popoverElement.close();
      }, 300);
    }
  }

  eventChange() {
    /*if(this.element.control.valueChanges){
      this.laudoService.change(this.element.control.value);
    }*/
  }

}
